import { render, staticRenderFns } from "./SupplierAdd.vue?vue&type=template&id=4339c774&scoped=true"
import script from "./SupplierAdd.vue?vue&type=script&lang=ts"
export * from "./SupplierAdd.vue?vue&type=script&lang=ts"
import style0 from "./SupplierAdd.vue?vue&type=style&index=0&id=4339c774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4339c774",
  null
  
)

export default component.exports